import { render } from "./modal.vue?vue&type=template&id=36598c3c"
import script from "./modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./modal.vue?vue&type=script&setup=true&lang=ts"

import "./modal.vue?vue&type=style&index=0&id=36598c3c&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "36598c3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36598c3c', script)) {
    api.reload('36598c3c', script)
  }
  
  module.hot.accept("./modal.vue?vue&type=template&id=36598c3c", () => {
    api.rerender('36598c3c', render)
  })

}

script.__file = "resources/scripts/components/ui/modal.vue"

export default script